//=include  ../dataLayer.js
import DataLayer from '../dataLayer'

export default class BookerTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
        this.pages = window.__pt.fn.analytics.pages;
        this.fn = window.__pt.fn || {}

    }

    metricBookerHotel(fn, arg) {
        const { data, vmData, element } = arg;

        const paramsBySite = {
            'PT': {
                event: this.events.trackEvent,
                eventName: this.events.search,
                checkIn: data.checkin,
                checkOut: data.checkout,
                placeId_destination: data.placeId,
                rooms: data.rooms,
                nights: this.countNight(data.checkin, data.checkout),
                adults: data.adults,
                layer: this.settings.page,
                children: data.infants + data.kids,
                place_name_destination: vmData.place_name,
                search_type: "hotel",
            },
            'TB': {
                event: `ga4.${this.events.trackEvent}`,
                eventName: this.events.search,
                eventParams: {
                    action: this.events.click,
                    search_term: vmData.place_name,
                    element: element,
                    search_type: this.events.hotel,
                    field_destination: data.placeId,
                    field_date1: data.checkin,
                    field_date2: data.checkout,
                    field_rooms: data.rooms,
                    field_total_nights: this.countNight(data.checkin, data.checkout),
                    travelers_adults: data.adults,
                    travelers_children: data.infants + data.kids,
                    content_type: this.events.button,
                    page_type: this.pages[this.settings.page],
                    layer: this.events.hotels
                },
            },
            'US': {
                event: `ga4.${this.events.trackEvent}`,
                eventName: this.events.search,
                eventParams: {
                    action: this.events.click,
                    search_term: vmData.place_name,
                    element: element,
                    search_type: this.events.hotel,
                    field_destination: data.placeId,
                    field_date1: data.checkin,
                    field_date2: data.checkout,
                    field_rooms: data.rooms,
                    field_total_nights: this.countNight(data.checkin, data.checkout),
                    travelers_adults: data.adults,
                    travelers_children: data.infants + data.kids,
                    content_type: this.events.button,
                    page_type: this.pages[this.settings.page],
                    layer: this.events.hotels
                },
            },
        }

        const objMetric = paramsBySite[this.settings.site.metricsSuffix];

        this.analytics.set(objMetric.event, objMetric);
    }

    metricBookerFlight(fn, arg) {
        const { data, vmData } = arg;


        const objMetric = {
            event: this.events.trackEvent,
            eventName: this.events.search,
            checkIn: data.startingFromDateTime,
            checkOut: data.returningFromDateTime,
            placeId_destination: vmData.place_selected_to.id,
            rooms: 1,
            typeFlight: (data.mode == 1) ? "redondo" : (data.mode == 0) ? "sencillo" : "",
            nameOrigin: vmData.place_selected.displayText,
            nights: this.countNight(data.startingFromDateTime, data.returningFromDateTime),
            adults: data.adults,
            layer: this.settings.page,
            children: data.kids,
            place_name_destination: vmData.place_selected_to.displayText,
            search_type: "vuelo",
        }

        this.analytics.set(objMetric.event, objMetric);
    }
    //Botón: Módificar Búsqueda en recomendación
    metricModifiedSearchRecomendation(content = "recomendacion") {
        const data = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            content_type: this.events.button,  
            element: `${content}::modificar_busqueda`,
            layer: this.events.hotels,    
            page_type: this.settings.page
        }
        this.analytics.set(this.events.trackEvent, data);
    }
    metricBookerPackage(fn, arg) {
        const { data, vmData } = arg;


        const objMetric = {
            event: this.events.trackEvent,
            eventName: this.events.search,
            field_date1: data.CheckIn,
            field_date2: data.CheckOut,
            field_destination: vmData.place_selected_to.placeId,
            field_rooms: data.rooms,
            field_total_nights: this.countNight(data.CheckIn, data.CheckOut),
            layer: this.settings.page,
            search_term: vmData.place_name,
            search_type: "hotel+vuelo",
            travelers_adults: data.adults,
            travelers_children: data.infants + data.kids
        }

        this.analytics.set(objMetric.event, objMetric);
    }

    metricRecentSearch(element) {

        const objMetric = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page,
            content_type: this.events.link,
            element: `booker_recent_search:: ${element}`,
            page_type: this.settings.page
        }

        this.analytics.set(objMetric.event, objMetric);
    }

    availabilityCalendar(events) {
        let eventsLength = events.length;

        for (var i = 0; i < eventsLength; i++) {
            const event = events[i];
            const objMetric = {
                event: this.events.gtmEvent,
                eventName: this.events.gtmEvent,
                eventCategory: "calendar no dispo",
                eventAction: event.action,
                eventLabel: event.label
            }
            this.analytics.set(objMetric.event, objMetric);
        }
    }

    countNight(checkInStr, checkOutStr) {
        let checkIn = this.fn.getDate(checkInStr);
        let checkOut = this.fn.getDate(checkOutStr);
        let days = this.fn.diffBetweenDays(checkIn, checkOut);

        return days;
    };

    metricDatesRecommended(eventName, arg) {
        const { data } = arg;

        const paramsBySite = {
            event: this.events.trackEvent,
            eventName: eventName,
            hotelId: data.hotelId,
            checkIn: data.checkIn,
            checkOut: data.checkOut,
            nights: this.countNight(data.checkin, data.checkout),
            adults: data.adults,
            children: data.children,
            layer: this.settings.page,
            search_type: "hotel"
        }

        const objMetric = {...paramsBySite};

        this.analytics.set(objMetric.event, objMetric);
    }
}
